import { useState } from 'react';
import classes from 'classnames';
import copy from 'copy-to-clipboard';
import Button from 'components/Button/Button';
import styles from 'components/CopyValue/CopyValue.module.scss';

export type Props = {
  label: string;
  value: string;
  copyLabel: string;
  confirmLabel?: string;
  className?: string;
  dataTest?: string;
};

function CopyValue({
  label,
  value,
  copyLabel,
  confirmLabel,
  className,
  dataTest = 'copyValue',
}: Props) {
  const [confirmed, setConfirmed] = useState(false);
  const handleClick = () => {
    try {
      copy(value);
      // display a confirmation message for 2 seconds
      setConfirmed(true);
      setTimeout(() => {
        setConfirmed(false);
      }, 2000);
    } catch {
      /* empty */
    }
  };
  return (
    <div className={classes(styles.wrapper, className)} data-test={dataTest}>
      <div className={styles.info} data-test={`${dataTest}-info`}>
        <div className={styles.label} data-test={`${dataTest}-label`}>
          {label}
        </div>
        <div className={styles.value} data-test={`${dataTest}-value`}>
          {value}
        </div>
      </div>
      <div className={styles['confirm-wrapper']}>
        {confirmLabel && confirmed && (
          <div className={styles.confirm} data-test={`${dataTest}-confirm`}>
            {confirmLabel}
          </div>
        )}
      </div>
      <Button
        className={styles.button}
        outline
        size="s"
        onClick={handleClick}
        dataTest={`${dataTest}-btn`}
      >
        {copyLabel}
      </Button>
    </div>
  );
}

export default CopyValue;
